<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item label="用户账号">
        <el-input v-model="queryForm.userName"></el-input>
      </el-form-item>
      <el-form-item label="产品名称">
        <el-input v-model="queryForm.productName"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getShopUserCollectionList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetDialog"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group"></div>

        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshShopUserCollectionList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        height='100%'
        :data="shopUserCollectionList"
        row-key="id"
        @selection-change="handleSelectionChange"
        size="small"
      >
        <el-table-column
          align="center"
          type="selection"
          width="60"
        > </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="mppUser.userName"
          label="用户账号"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="shopProduct.productName"
          label="产品名称"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="shopProduct.productPic"
          label="产品图片"
          min-width="8%"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.shopProduct">
                <el-image
                    @click='updateSrcList(scope.row.shopProduct.productPic)'
                    style="width: 30px; height: 30px"
                    :src="scope.row.shopProduct.productPic"
                    :preview-src-list="srcList"
                > </el-image>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="shopProduct.shopPrice"
          label="产品价格"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="createTime"
          label="创建时间"
          min-width="10%"
        >
          <template slot-scope="scope">
            <div>{{ $moment(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopUserCollectionList();
                this.getShopUserCollectionList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopUserCollectionList();
                this.getShopUserCollectionList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                productName: '',
                userName: ''
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopUserCollectionState: 'add',
            shopUserCollectionStates: {},

            multipleSelection: [],
            shopUserCollectionList: [],
            shopUserCollection: {},
            btnLoading: false,
            srcList:[''],//大图预览

        };
    },
    created() {
        this.getShopUserCollectionList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopUserCollectionList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopUserCollectionList = [];
        },
        resetDialog() {
            this.shopUserCollectionState = 'add';
            this.showDialog = false;
            this.queryForm = {
                productName: '',
                userName: ''
            };
            this.getShopUserCollectionList();
        },
        refreshShopUserCollectionList() {
            this.resetShopUserCollectionList();
            this.getShopUserCollectionList();
        },
        getShopUserCollectionList(query = {}) {
            this.loading = true;
            get(`/restaurant/productcollection/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then(
                (res) => {
                    this.loading = false;
                    if (res.success && res.code == 200) {
                        this.shopUserCollectionList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                }
            );
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopUserCollectionList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopUserCollectionList();
        },
        updateSrcList(src){
            this.srcList[0] = src
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.collection-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
</style>
